const style = {
  table: {
    padding: `20px`,
    border: `1px solid #ddd`,
    borderRadius: `3px`
  },
  row: {
    fontSize: `13px`,
    padding: `10px`,
    overflow: `hidden`,
    ':not(:last-of-type)': {
      borderBottom: `1px solid #ddd`
    }
  },
  col: {
    ':not(:last-of-type)': {
      borderRight: `1px solid #ddd`
    }
  },
  input: {
    fontSize: `13px`,
    textAlign: `right`,
    border: `0px`,
    color: `#666`,
    width: `100%`
  }
}

export default style



// WEBPACK FOOTER //
// ./src/components/Community/Application/Main/style/table.js